<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head" id="Intro">Introduction</p>
<p class="para1">Who do you call when you’ve seen a ghost?</p>
<p class="para">Ghostbusters? No, they were a great team, but unfortunately, not real. The real work of detecting ghosts and supernatural phenomena is done by volunteers called paranormal investigators. They use cutting-edge equipment to detect supernatural activity. Their bag of tricks includes infrared cameras to see in the dark, equipment to measure changes in the EMF (electromagnetic field), full-spectrum cameras to see sources of light the human eye can’t see. They even have equipment that records sounds that the human ear can’t hear. With their help, we’re going to investigate the ghostly mysteries of the Adirondacks.</p>
<p class="para">People have lived in the Adirondacks since the last Ice Age, which ended about 15,000 BC. Can you imagine how many lives have begun and ended in that time? Happy stories, sad stories, and spooky stories float around the Adirondacks, which covers over five thousand square miles!</p>
<p class="image-center"><img alt="Image" src="images/P8.jpg"/></p>
<p class="para">Joining a team of paranormal investigators, we’ll dig into some of the supernatural mysteries. This time, we won’t have rely only on our senses. We’ll have equipment the ghostbusters would have loved! Let’s go find some ghosts!</p>
<p class="image-center"><img alt="Image" src="images/P10.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Introduction.vue?bd7c215c